import * as React from "react";

const Warning = (props: any) => (
  <svg width={32} height={32} viewBox="0 0 32 32" {...props}>
    <g fillRule="nonzero" fill="none">
      <path
        d="M31.493 26.005L19.053 2.092C18.446.928 17.313.21 16.087.21c-1.227 0-2.36.718-2.967 1.882L.667 26.005a4.019 4.019 0 0 0 .023 3.71c.612 1.144 1.736 1.847 2.95 1.846h24.88c1.214 0 2.338-.702 2.95-1.846a4.019 4.019 0 0 0 .023-3.71z"
        fill="#F5A422"
      />
      <path
        d="M17.627 26.165c-.364.362-.84.56-1.334.552a1.892 1.892 0 0 1-1.333-.538 2.023 2.023 0 0 1-.587-1.527 2.15 2.15 0 0 1 .556-1.47 1.801 1.801 0 0 1 1.351-.596c.5-.002.98.213 1.333.597.364.379.567.906.56 1.454a2.047 2.047 0 0 1-.546 1.528zM18.133 12.303l-.493 6.094a5.294 5.294 0 0 1-.307 1.717c-.184.442-.595.718-1.04.698-.438.024-.846-.247-1.026-.684a6.272 6.272 0 0 1-.36-1.789l-.36-5.934c-.067-1.179-.107-1.993-.107-2.502a2.618 2.618 0 0 1 .547-1.746 1.816 1.816 0 0 1 1.44-.64c.615-.035 1.187.347 1.44.96.263.7.382 1.455.346 2.211-.002.54-.029 1.078-.08 1.615z"
        fill="#FFF"
      />
    </g>
  </svg>
);

export default Warning;

